// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__on5J8","textarea":"styles_textarea__2Gxly"};